import { render, staticRenderFns } from "./DashboardInvestmentBreakdown.vue?vue&type=template&id=48f14f16"
import script from "./DashboardInvestmentBreakdown.vue?vue&type=script&lang=js"
export * from "./DashboardInvestmentBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports